export class ListAwsVpcsResponse {
    'vpcs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcs",
            "baseName": "vpcs",
            "type": "Array<ListAwsVpcsResponseVpcsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAwsVpcsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
